var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPlusConsegna(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 69,
    viewBox: "0 0 101 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23_658-123032)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5 47.8999C19.7 47.8999 15 52.5999 15 58.3999C15 64.1999 19.7 68.8999 25.5 68.8999C31.3 68.8999 36 64.1999 36 58.3999C36 52.5999 31.3 47.8999 25.5 47.8999ZM25.5 65.6999C21.5 65.6999 18.2 62.3999 18.2 58.3999C18.2 54.3999 21.5 51.0999 25.5 51.0999C29.5 51.0999 32.8 54.3999 32.8 58.3999C32.8 62.3999 29.5 65.6999 25.5 65.6999Z",
    fill: "#E4441C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5001 54C23.1001 54 21.1001 56 21.1001 58.4C21.1001 60.8 23.1001 62.8 25.5001 62.8C27.9001 62.8 29.9001 60.8 29.9001 58.4C29.9001 56 27.9001 54 25.5001 54Z",
    fill: "#E4441C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3999 47.8999C73.5999 47.8999 68.8999 52.5999 68.8999 58.3999C68.8999 64.1999 73.5999 68.8999 79.3999 68.8999C85.1999 68.8999 89.8999 64.1999 89.8999 58.3999C89.8999 52.5999 85.1999 47.8999 79.3999 47.8999ZM79.3999 65.6999C75.3999 65.6999 72.0999 62.3999 72.0999 58.3999C72.0999 54.3999 75.3999 51.0999 79.3999 51.0999C83.3999 51.0999 86.6999 54.3999 86.6999 58.3999C86.6999 62.3999 83.3999 65.6999 79.3999 65.6999Z",
    fill: "#E4441C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4 54C77 54 75 56 75 58.4C75 60.8 77 62.8 79.4 62.8C81.8 62.8 83.8 60.8 83.8 58.4C83.8 56 81.8 54 79.4 54Z",
    fill: "#E4441C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5 26.8L90.7 23.1C89.6 21.1 85.3 13.7 81.9 10.7C81.6 10.4 81.2 10.3 80.8 10.3H67.7V1.6C67.7 0.7 67 0 66.1 0H1.6C0.7 0 0 0.7 0 1.6V40.7C0 41.6 0.7 42.3 1.6 42.3H4.4V54C4.4 54.9 5.1 55.6 6 55.6H13C13.7 55.6 14.3 55.2 14.5 54.5C16.1 49.9 20.5 46.8 25.4 46.8C30.3 46.8 34.7 49.9 36.3 54.5C36.5 55.1 37.1 55.6 37.8 55.6H66.9C67.6 55.6 68.2 55.2 68.4 54.5C70 49.9 74.4 46.8 79.3 46.8C84.2 46.8 88.6 49.9 90.2 54.5C90.4 55.1 91 55.6 91.7 55.6H98.8C99.7 55.6 100.4 54.9 100.4 54V40.9V28.3C100.4 27.7 100.1 27.1 99.5 26.8ZM67.7 13.6H80.2C83.6 16.9 88.1 25.1 88.1 25.2C88.3 25.5 88.6 25.8 88.9 25.9L97.3 29.4V39.3H67.7V13.6ZM3.2 7.9H7.2V34.6H3.2V7.9ZM9.3 7.9H13.6V34.6H9.3V7.9ZM15.7 7.9H20V34.6H15.7V7.9ZM22 7.9H26.3V34.6H22V7.9ZM28.4 7.9H32.7V34.6H28.4V7.9ZM34.8 7.9H39.1V34.6H34.8V7.9ZM41.1 7.9H45.4V34.6H41.1V7.9ZM47.5 7.9H51.8V34.6H47.5V7.9ZM53.9 7.9H58.2V34.6H53.9V7.9ZM60.2 7.9H64.5V34.6H60.2V7.9ZM3.2 3.2H64.5V5.6H3.2V3.2ZM3.2 39.1V36.8H64.5V39.1H3.2ZM97.2 52.4H92.8C90.4 47.1 85.2 43.6 79.3 43.6C73.5 43.6 68.2 47.1 65.8 52.4H39C36.6 47.1 31.4 43.6 25.5 43.6C19.6 43.6 14.4 47.1 12 52.4H7.6V42.5H66.1H97.2V52.4Z",
    fill: "#E4441C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1 16.3H69.7V26.3H85.3L85.2 26.2001C83.4 23.3001 80.4 18.8 78.1 16.3Z",
    fill: "#E4441C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9999 30.1001H71.8999V31.9001H76.9999V30.1001Z",
    fill: "#E4441C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 62,
    height: 36,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_658-123032"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100.4,
    height: 68.9,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlusConsegna);
export default __webpack_public_path__ + "static/media/icon_plus-consegna.610a95289b53d2a75aa93f5ae04aeee5.svg";
export { ForwardRef as ReactComponent };